// Hides the Shopify Inbox chat bubble while the cart drawer or mobile
// menu is open. Both already toggle body.overflow-hidden. The widget
// renders inside an open Shadow DOM (<inbox-online-store-chat>) whose
// own stylesheet sets `:host { display: block !important; }`, which
// can beat a plain CSS rule from the page — so we set the inline
// style with !important directly on the host element instead, via a
// MutationObserver watching body's class list.
(function () {
  function syncChatVisibility() {
    var chat = document.querySelector('inbox-online-store-chat');
    if (!chat) return;

    if (document.body.classList.contains('overflow-hidden')) {
      chat.style.setProperty('display', 'none', 'important');
    } else {
      chat.style.removeProperty('display');
    }
  }

  var observer = new MutationObserver(syncChatVisibility);

  function init() {
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    syncChatVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
